import {Injectable} from '@angular/core'
import { AppConfig } from '../../../config/app.config';
import { TranslateService } from '@ngx-translate/core';
import { Localization } from "../enums/localization";

@Injectable()
export class InputValidationService {
    constructor(private appConfig: AppConfig, private translate: TranslateService) {}

    public isLabelTooLong(label): boolean {
        return label != null && label.length > this.appConfig.DOCUMENT_LABEL_MAX_LENGTH;
      }

    public getTooLongInputMessage(): string {
        return this.translate.instant(Localization.MaxLengthAllowedIs, {value: this.appConfig.DOCUMENT_LABEL_MAX_LENGTH});
    }
}